import { Link } from "react-router-dom";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import "./styles.css";

// import required modules
import { Pagination, Autoplay } from "swiper";

export default function App() {
  return (
    <>
      <Swiper
        pagination={{
          dynamicBullets: true,
        }}
        modules={[Pagination, Autoplay]}
        autoplay={true}
        className="mySwiper"
      >
         <SwiperSlide>
          <Link to="/product/62de7d287c3f888286fb0466" className="h-full w-full">
          <div className="flex h-full w-full grid-cols-2 bg-[#111] rounded-md p-2 md:p-6 lg:p-8">
            <div className="left flex-1 flex flex-col self-start text-left h-full justify-center relative">
                <h3 className="hidden text-xs lg:block md:text-base text-secondary font-medium font-Roboto absolute top-0">check the new offer </h3>
              <h3 className="brand text-xs md:text-base text-white font-medium font-Roboto">
                Razer
              </h3>
              <h1 className="title text-sm md:text-lg mb-1 lg:text-xl lg:mb-2 text-white font-semibold font-Roboto">
                PC gaming accessories Bundle
              </h1>
              <p className="price text-xs text-primary font-Roboto py-1">
                $250.99 <br className="hidden lg:block"/>%20 sale off
              </p>
              <h2 className="hidden md:flex text-white bg-primary w-fit rounded-md py-2 mt-4 px-4 font-semibold font-Roboto shadow-md hover:bg-primary-200">
                Buy now
              </h2>
            </div>
              
            <div className="right h-full justify-end flex-1">
              <img
                className="h-full object-cover md:object-contain "
                src="https://assets3.razerzone.com/bXIOcWCYrTslUQDHZLt3qa4-4Zk=/1500x1000/https%3A%2F%2Fhybrismediaprod.blob.core.windows.net%2Fsys-master-phoenix-images-container%2Fh58%2Fh21%2F9418929799198%2F220712-striking-immersion-1500x1000-1.jpg"
                alt="Macbook"
              />
            </div>
            </div>
            </Link>
        </SwiperSlide>

         <SwiperSlide>
          <Link to="/product/62c204c38c30bd210921745f" className="h-full w-full">
          <div className="flex h-full w-full grid-cols-2 bg-[#111] rounded-md p-2 md:p-6 lg:p-8">
            <div className="left flex-1 flex flex-col self-start text-left h-full justify-center relative">
                <h3 className="hidden text-xs lg:block md:text-base text-secondary font-medium font-Roboto absolute top-0">check the new offer </h3>
              <h3 className="brand text-xs md:text-base text-white font-medium font-Roboto">
              Apple
              </h3>
              <h1 className="title text-sm md:text-lg mb-1 lg:text-xl lg:mb-2 text-white font-semibold font-Roboto">
              MacBook pro
              </h1>
              <p className="price text-xs text-primary font-Roboto py-1">
                $1999.99 <br className="hidden lg:block"/>%5 sale off
              </p>
              <h2 className="hidden md:flex text-white bg-primary w-fit rounded-md py-2 mt-4 px-4 font-semibold font-Roboto shadow-md hover:bg-primary-200">
                Buy now
              </h2>
            </div>
              
            <div className="right h-full justify-end flex-1">
              <img
                className="h-full object-cover md:object-contain "
                src="https://freepngimg.com/thumb/macbook/70211-apple-mockup-pro-drive-air-laptops-disc.png"
                alt="product"
              />
            </div>
            </div>
            </Link>
        </SwiperSlide>

         <SwiperSlide>
          <Link to="/product/62de63042990b4f13efc1a6e" className="h-full w-full">
          <div className="flex h-full w-full grid-cols-2 bg-[#111] rounded-md p-2 md:p-6 lg:p-8">
            <div className="left flex-1 flex flex-col self-start text-left h-full justify-center relative">
                <h3 className="hidden text-xs lg:block md:text-base text-secondary font-medium font-Roboto absolute top-0">check the new offer </h3>
              <h3 className="brand text-xs md:text-base text-white font-medium font-Roboto">
                Razer
              </h3>
              <h1 className="title text-sm md:text-lg mb-1 lg:text-xl lg:mb-2 text-white font-semibold font-Roboto">
              Wireless gaming mouse
              </h1>
              <p className="price text-xs text-primary font-Roboto py-1">
                $79.99 <br className="hidden lg:block"/>%10 sale off
              </p>
              <h2 className="hidden md:flex text-white bg-primary w-fit rounded-md py-2 mt-4 px-4 font-semibold font-Roboto shadow-md hover:bg-primary-200">
                Buy now
              </h2>
            </div>
              
            <div className="right h-full justify-end flex-1">
              <img
                className="h-full object-cover md:object-contain "
                src="https://assets3.razerzone.com/U-v0ztWgvi4yWGLZbvyOW6dW5oA=/1500x1000/https%3A%2F%2Fhybrismediaprod.blob.core.windows.net%2Fsys-master-phoenix-images-container%2Fh61%2Fhed%2F9086247927838%2FdeathadderV2pro-gallery-1500x1000-img7.jpg"
                alt="Macbook"
              />
            </div>
            </div>
            </Link>
        </SwiperSlide>
    
      </Swiper>
    </>
  );
}
